<template>
    <div class="brand-wrapper">
        <h6 class="title">合作伙伴</h6>
        <div class="logo-box flex-center">
            <div v-for="(item,index) in imglist" class="items">
                <img :src="item.image" alt="">
            </div>
          
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
			imglist:[],
 
		}
	},

    methods: {
   
		async getSet() {
			console.log('go...');
			let fdata = { do: 'json', sjk: 'bootimgs',limit:10 }
			let res = await this.$api.funk(fdata)
			this.imglist = res
			console.log('imglist：' + this.imglist);
		}
 
    },
    created(option) {
        
        this.getSet()
    },

}
</script>
<style lang="scss" scoped>
.brand-wrapper {
    width: 16.2rem;
    margin: 0 auto;
    margin-top: 0.24rem;
    margin-bottom: 0.24rem;
    border-top: 1px solid #E5E7EB;
    border-bottom: 1px solid #E5E7EB;
    padding: 0.32rem 0 0.56rem 0;

    .title {
        text-align: center;
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 0.32rem;
        line-height: 0.32rem;
        color: #000000;
        margin-bottom: 0.54rem;
    }

    .logo-box {
        margin-bottom: 0.4rem;

        .items {
            height: 0.68rem;
            margin: 0 0.44rem;

            img {
                object-fit: contain;
                height: 100%;
                display: block;
            }
        }
    }
}

@media (max-width: 750px) {
    .brand-wrapper {
        width: 100%;
        padding-top: 0.48rem;
    }

    .brand-wrapper .logo-box {
        flex-wrap: wrap;
    }

    .brand-wrapper .logo-box .items {
        margin-bottom: 0.4rem;
        height: 0.6rem;
    }

    .brand-wrapper .title {
        margin-bottom: 0.8rem;
        font-size: 0.48rem;
        line-height: 0.48rem;
    }
}
</style>